import { Box, Typography, Grid, Paper } from '@mui/material';

const getImgSrc = (img) => (typeof img === 'string' ? img : img?.url || '');

const DeliveryImages = ({ images = [], title = 'Imágenes de Entrega', imgHeight = 400 }) => {
  return (
    images.length > 0 && (
      <Box mt={4}>
        <Typography variant="h6" align="center" gutterBottom>
          {title}
        </Typography>

        <Box display="flex" justifyContent="center">
          <Grid container spacing={2} justifyContent="center"
            sx={{ maxWidth: "1400px" }}>
            {images.map((imgUrl, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                <Paper elevation={3} sx={{ p: 1 }}>
                  <Typography variant="body2" align="center" gutterBottom>
                    Imagen {index + 1}
                  </Typography>
                  <Box
                    sx={{
                      width: '100%',
                      height: `${imgHeight}px`, // altura fija en px
                      overflow: 'hidden',
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderRadius: '8px',
                      display: 'flex',
                    }}
                  >
                    <img
                      src={getImgSrc(imgUrl)}
                      alt={`Imagen ${index + 1}`}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                      }}
                    />
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    )
  );
};

export default DeliveryImages;
